import utils from '../libs/utils';
import axios from './axios';

// /download/file/list
const MODULE_NAME = 'v1/erp-sys-web';
export default {
  getDownloadFile(params) { // 导出中的文件（轮询接口）
    return axios.get(`${MODULE_NAME}/download/file/listDownloading?${utils.exchangeParams(params)}`);
  },
  getDownloadList(params) { // 导出文件列表
    return axios.get(`${MODULE_NAME}/download/file/list?${utils.exchangeParams(params)}`);
  },
  downloadFile(params) { // 导出列表 - 下载
    return axios.get(`${MODULE_NAME}/download/file/download?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  deleteDownloadFile(params) { // 导出列表 - 删除
    return axios.get(`${MODULE_NAME}/download/file/delete?${utils.exchangeParams(params)}`);
  },
  getMenuList(params) { // 导出列表 - 删除
    return axios.get(`${MODULE_NAME}/download/file/listMenuList?${utils.exchangeParams(params)}`);
  },
};
